//#region src/schema/localization/locales/pt.ts
var e = {
	schema: {
		variants: "Variantes",
		discriminatorValue: "Valor do discriminador",
		noAllowedValues: "Nenhum valor satisfaz esta restrição enum.",
		example: "Exemplo",
		examples: "Exemplos",
		default: "Padrão",
		schema: "Schema",
		emptyObject: "Objeto vazio",
		showAdditionalProperties: "Mostrar propriedades adicionais",
		showOneMoreProperty: "Mostrar mais 1 propriedade",
		showMoreProperties: "Mostrar mais {count} propriedades",
		forName: "para {name}",
		showSchemaDetails: "Mostrar Detalhes do Schema",
		oneOf: "Um de",
		anyOf: "Qualquer um de",
		allOf: "Todos de",
		not: "Não",
		unknownType: "tipo desconhecido",
		propertyCount: "Propriedades: {count}",
		headerCount: "Cabeçalhos: {count}",
		recursiveReference: "Referência recursiva a {name}",
		recursive: "recursivo",
		additionalProperties: "propriedades adicionais",
		const: "const",
		deprecated: "obsoleto",
		discriminator: "Discriminador",
		enum: "enum",
		format: "Formato",
		greaterThan: "maior que",
		keys: "chaves",
		lessThan: "menor que",
		max: "máx",
		min: "mín",
		maxLength: "tamanho máximo",
		minLength: "tamanho mínimo",
		multipleOf: "múltiplo de",
		nullable: "aceita nulo",
		propertyNames: "nomes de propriedades",
		pattern: "Padrão",
		copyPattern: "Copiar padrão",
		readOnly: "somente leitura",
		required: "obrigatório",
		hideValues: "Ocultar valores",
		showAllValues: "Mostrar todos os valores",
		type: "Tipo",
		unique: "único",
		values: "valores",
		writeOnly: "somente escrita",
		typeInteger: "Números inteiros.",
		formatInt32: "Inteiros de 32 bits com sinal (tipo inteiro mais comum).",
		formatInt64: "Inteiros de 64 bits com sinal (tipo long).",
		formatDate: "notação full-date definida pela RFC 3339, seção 5.6, por exemplo, 2017-07-21",
		formatDateTime: "notação date-time definida pela RFC 3339, seção 5.6, por exemplo, 2017-07-21T17:32:28Z",
		formatPassword: "indica às interfaces que ocultem a entrada",
		formatBase64: "caracteres codificados em base64, por exemplo, U3dhZ2dlciByb2Nrcw==",
		formatBinary: "dados binários, usados para descrever arquivos"
	},
	common: {
		copyDefault: "Copiar valor padrão",
		copyExample: "Copiar valor de exemplo"
	},
	actions: { copyLinkTo: "Copiar link para {name}" }
};
//#endregion
export { e as pt };

//# sourceMappingURL=pt.js.map